import React from 'react'
import { Card, MenuItem, TextField, CardContent, Button, FormControl, Grid } from '@mui/material';

import { LinearLoading, CustomAutocomplete } from 'common'

export const FormStampsLogs = ({ useFetchInit }) => {

    const {
        //------------- Generales
        //------------- globalStates
        // globalStates,
        //------------- Helpers
        // Helpers,
        //------------- Formularios
        Forms,
        //------------- FetchData
        FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    // ------------------------------------------------ Generales
    
    // ------------------------------------------------ globalStates
    // const { showForm } = globalStates

    // ------------------------------------------------ Helpers
    
    // ------------------------------------------------ Formularios
    const { FormScreen } = Forms
    const { formState, onInputChange, onInputNumberChange, onSelectSearchChange } = FormScreen
    
    // ------------------------------------------------ FetchData
    const { fetchSpecificStampLog, fetchStamps } = FetchData
    const { loadingFetchSpecificStampLog } = fetchSpecificStampLog
    const { dataStamps } = fetchStamps

    // ------------------------------------------------ Actions
    const { onSubmitForm, handleClickHideForm } = Actions

    const isReadOnly = formState.idstamplogs > 0
    return (
        <div className='content'>
            <Card style={{zIndex:'1'}}>
                <CardContent>
                    <div className='h4 mt-1 mb-1'>
                        {isReadOnly
                            ? 'Actualizar Registro'
                            : 'Crear Registro'}
                    </div>
                    <div className="border-bottom border-dark"></div>
                    {loadingFetchSpecificStampLog && ( <LinearLoading /> )}

                    <div className="pt-3"></div>
                    <p className='text-danger'>* campos obligatorios</p>
                    <div className="pt-2"></div>

                    <form onSubmit={onSubmitForm}>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <FormControl fullWidth>
                                    <label htmlFor="date_transaction">* Fecha</label>
                                    <TextField
                                        id="date_transaction"
                                        name="date_transaction"
                                        value={formState.date_transaction}
                                        onChange={onInputChange}
                                        size='small'
                                        type="date"
                                        variant="filled"
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: isReadOnly,
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <FormControl fullWidth>
                                    <label htmlFor="type_transaction">Tipo</label>
                                    <TextField
                                        id="type_transaction"
                                        name="type_transaction"
                                        placeholder="Selecciona una opción"
                                        // label="Tipo"
                                        value={formState.type_transaction}
                                        onChange={onInputChange}
                                        select
                                        size="small"
                                        lable="Selecciona una opción"
                                        variant={(isReadOnly)?"filled":"outlined"}
                                        hiddenLabel
                                        InputProps={{ readOnly: isReadOnly }}
                                    >
                                        <MenuItem value=''>-- Selecciona una opción --</MenuItem>
                                        <MenuItem value='INGRESO'>INGRESO</MenuItem>
                                        <MenuItem value='EGRESO'>EGRESO</MenuItem>
                                    </TextField>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <div className="pt-4"></div>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <FormControl fullWidth>
                                    <label htmlFor="idstamp">* Timbre</label>
                                    <CustomAutocomplete 
                                        customId="idstamp"
                                        customName="idstamp"
                                        customValue={formState.idstamp}
                                        customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'idstamp', value: value.value }})}
                                        customPlaceholder='Selecciona una opcion'
                                        customOptions={
                                            dataStamps.map(({ idstamp, stamp }) => ({
                                                value: idstamp,
                                                name: stamp
                                            }))
                                        }
                                        customDisableClearable={true}
                                        customDisabled={isReadOnly}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <FormControl fullWidth>
                                    <label htmlFor="quantity">* Cantidad</label>
                                    <TextField
                                        id="quantity"
                                        name="quantity"
                                        value={formState.quantity}
                                        onChange={onInputNumberChange}
                                        size='small'
                                        type="number"
                                        step="1"
                                        min="0"
                                        variant={(isReadOnly)?"filled":"outlined"}
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: isReadOnly,
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                        <div className="pt-4"></div>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <FormControl fullWidth>
                                    <label htmlFor="observations">Observaciones</label>
                                    <TextField
                                        id="observations"
                                        name="observations"
                                        value={formState.observations}
                                        onChange={onInputChange}
                                        // label='Modelo'
                                        size='small'
                                        multiline
                                        rows={3}
                                        type="text"
                                        variant={(isReadOnly)?"filled":"outlined"}
                                        hiddenLabel
                                        InputProps={{
                                            readOnly: isReadOnly,
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>

                        <div className="pt-4"></div>
                        <Grid container>
                            <Grid item>
                                <div className='update ml-auto mr-auto'>
                                    <Button
                                        style={{background: "#4b4b4c"}}
                                        variant="contained"
                                        type='submit'
                                        disabled={isReadOnly}
                                    >
                                        <i className="fa-regular fa-floppy-disk"></i> &nbsp; Guardar
                                    </Button>
                                    &nbsp; &nbsp;
                                    <Button
                                        style={{ marginRight: 2, marginLeft: 2, background: "#ef8157" }}
                                        type='button'
                                        variant="contained"
                                        onClick={handleClickHideForm}
                                    >
                                        <i className="fa-regular fa-circle-left"></i> &nbsp; Cancelar
                                    </Button>
                                </div>
                            </Grid>
                        </Grid>
                    </form>
                </CardContent>
            </Card>
        </div>
    )
}
